import React from 'react'
import type { Icon } from 'shared/utils'
import { COLOR } from 'app-v2/design-tokens'

const ForbiddenIcon = (props: Icon) => {
    const {
        color = COLOR.PRIMARY,
        size = 24,
        className = 'forbidden',
        ...otherProps
    } = props
    return (
        <svg
            width={size}
            height={size}
            fill={color}
            className={className}
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12.0182 2.40041C10.1188 2.39688 8.26097 2.9569 6.67991 4.00962C5.09885 5.06233 3.86562 6.56041 3.13628 8.31426C2.40695 10.0681 2.21429 11.9989 2.58269 13.8623C2.95109 15.7257 3.86399 17.4379 5.20586 18.7823C6.54773 20.1267 8.25825 21.0427 10.121 21.4146C11.9837 21.7865 13.9148 21.5974 15.67 20.8713C17.4252 20.1453 18.9256 18.9148 19.9813 17.3357C21.0369 15.7566 21.6004 13.8999 21.6004 12.0004C21.5957 9.45886 20.5852 7.02249 18.7897 5.22367C16.9943 3.42485 14.5598 2.40983 12.0182 2.40041V2.40041ZM12.0182 5.96918C12.9782 5.97123 13.9237 6.20377 14.7751 6.64725L6.74538 14.677C6.26769 13.7618 6.03515 12.7386 6.0704 11.7068C6.10565 10.6751 6.40749 9.67009 6.94652 8.78967C7.48556 7.90924 8.24341 7.18342 9.14628 6.68289C10.0491 6.18236 11.0662 5.92418 12.0985 5.93349L12.0182 5.96918ZM12.0182 17.9424C11.0595 17.9709 10.108 17.769 9.24352 17.3536L17.2733 9.32383C17.7284 10.2287 17.9462 11.2345 17.9061 12.2466C17.866 13.2588 17.5693 14.2441 17.044 15.1102C16.5186 15.9762 15.7818 16.6946 14.9027 17.1978C14.0236 17.701 13.0311 17.9726 12.0182 17.987V17.9424Z"
                fill="#F5EBDC"
            />
        </svg>
    )
}

export { ForbiddenIcon }
